import {css} from '@logistics-frontend/blocks/theme/css'

export const body = css`
  background: transparent;
`
